import { ArrowUpRight, Search } from 'lucide-react';

/**
 * `/pure-search` — moved, and this is the note that says where.
 *
 * The Pure Customer Search was deregistered on 2026-09-12 (migration 200, phase P8
 * of the Pure Brain masterplan). Everything it did now lives in an application of
 * its own at **pure.dolderapps.com**, together with the things this page could not
 * carry: a knowledge base that learns from corrections and project debriefings, the
 * supplier and Regulatory safety-data-sheet archives beside the customer share, a
 * customer overview, the HubSpot project list, and a mailbox that reads forwarded
 * mail.
 *
 * ## Why a note and not a deleted route
 *
 * The route is kept, and it is the only thing that is. The search client, the answer
 * builder, the prompt, the dossier map, the two API functions and the panels were
 * all removed in the same commit — this file imports none of them, and nothing here
 * talks to a search index or to a model.
 *
 * There is no permission check, on purpose. The page row is `IsActive = 0`, so the
 * entry is gone from the navigation and from the permission matrix; a note saying
 * *this moved* is not something to be authorised for, and it reveals nothing. The
 * previous version of this file checked `usePagePermissions('/pure-search')`, which
 * after migration 200 would have shown every visitor *No access* — technically
 * correct, and useless to the person reading it.
 *
 * When the bookmarks have died out, this file goes too.
 */
export function PureSearchPage() {
    return (
        <div className="mx-auto max-w-2xl px-4 py-16">
            <div className="mb-4 flex items-center gap-2">
                <Search className="h-6 w-6 text-emerald-600" />
                <h1 className="text-xl font-semibold text-slate-800">
                    Pure Customer Search has moved
                </h1>
            </div>

            <p className="text-sm text-slate-600">
                The search over the BU Pure customer share is now part of{' '}
                <span className="font-medium text-slate-800">Pure Brain</span>, an
                application of its own.
            </p>
            <p className="mt-3 text-sm text-slate-500">
                It searches the same customer share, and beside it the supplier safety data
                sheets, the group&rsquo;s Regulatory archive and everything the Pure team has
                taught it since. Project debriefings, the customer overview and the HubSpot
                project list live there too.
            </p>

            <a
                href="https://pure.dolderapps.com"
                className="mt-8 inline-flex items-center gap-2 rounded-md bg-emerald-600 px-4 py-2
                           text-sm font-medium text-white transition-colors hover:bg-emerald-500"
            >
                Open Pure Brain
                <ArrowUpRight className="h-4 w-4" />
            </a>

            <p className="mt-6 text-xs text-slate-400">
                pure.dolderapps.com &middot; access is managed in that app&rsquo;s own
                settings. If it does not let you in, ask Roman.
            </p>
        </div>
    );
}
